"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectTime = connectTime;

var _react = _interopRequireDefault(require("react"));

var _useTime = require("./use-time");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_COMPONENT_CONFIG = {
  timeProp: "currentTime"
};

function validateComponentConfig(componentConfig) {
  if (typeof componentConfig.timeProp !== "undefined" && (typeof componentConfig.timeProp !== "string" || componentConfig.timeProp === "")) {
    throw new Error("timeProp must be a non-empty string value");
  }
}

function connectTime(timerConfig) {
  var componentConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  validateComponentConfig(componentConfig);
  var usedTimerConfig = timerConfig || {};

  var usedComponentConfig = _objectSpread(_objectSpread({}, DEFAULT_COMPONENT_CONFIG), componentConfig);

  return function (WrappedComponent) {
    return function TimeComponent(props) {
      var timeProps = _objectSpread(_objectSpread({}, props), {}, _defineProperty({}, usedComponentConfig.timeProp, (0, _useTime.useTime)(usedTimerConfig)));

      return /*#__PURE__*/_react.default.createElement(WrappedComponent, timeProps);
    };
  };
}